module.exports = __webpack_public_path__ + "i/bg_section_1.jpg";